export default __webpack_public_path__ + "static/media/IconF6.ed66e5a4.svg";